import L from 'leaflet'

/** Marcador circular do hover sincronizado com o SpeedChart. */
export const MAP_HOVER_MARKER_SIZE = 14

/** Altura aproximada do “bico” inferior do `MapArrowTooltip`. */
const MAP_ARROW_TOOLTIP_POINTER_PX = 8

export const MAP_ARROW_TOOLTIP_LEAFLET_CLASS = 'leaflet-tooltip-rich'

export function mapArrowTooltipLeafletOptions(
  interactive = true,
): L.TooltipOptions {
  return {
    className: MAP_ARROW_TOOLTIP_LEAFLET_CLASS,
    direction: 'top',
    offset: L.point(0, -MAP_ARROW_TOOLTIP_POINTER_PX),
    opacity: 1,
    interactive,
  }
}

export function createMapHoverMarkerIcon(html: string): L.DivIcon {
  const half = MAP_HOVER_MARKER_SIZE / 2
  return L.divIcon({
    className: '',
    iconSize: L.point(MAP_HOVER_MARKER_SIZE, MAP_HOVER_MARKER_SIZE),
    iconAnchor: L.point(half, half),
    tooltipAnchor: L.point(0, -half),
    html,
  })
}

/** Recalcula posição após o React montar o conteúdo (largura/altura reais). */
export function scheduleLeafletOverlayLayoutUpdate(
  overlay: L.Tooltip | L.Popup | null | undefined,
) {
  if (!overlay?.update) return
  requestAnimationFrame(() => {
    overlay.update()
    requestAnimationFrame(() => overlay.update())
  })
}
